import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  CardActions, 
  Button, 
  Divider,
  IconButton,
  Tooltip
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { PlaylistData } from '../../services/ai';

interface GeneratedPlaylistProps {
  playlist: PlaylistData;
  onCreateInSpotify: (playlist: PlaylistData) => void;
}

const GeneratedPlaylist: React.FC<GeneratedPlaylistProps> = ({ 
  playlist, 
  onCreateInSpotify 
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>AI Generated Playlist</Typography>
      <Card>
        <CardContent>
          <Typography variant="h5">{playlist.playlist_name}</Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            {playlist.description}
          </Typography>
          <Typography variant="body2" gutterBottom>
            {playlist.tracks.length} tracks • AI Generated
          </Typography>
          
          <Divider sx={{ my: 2 }} />
          
          <Typography variant="subtitle1" gutterBottom>Tracks:</Typography>
          {playlist.tracks.map((track, index) => (
            <Box key={`${track.artist}-${track.track}`} sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ mr: 1, minWidth: '20px' }}>
                    {index + 1}.
                  </Typography>
                  <Box>
                    <Typography variant="body2">{track.track}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {track.artist}
                    </Typography>
                  </Box>
                </Box>
                <Tooltip title="Search on Spotify">
                  <IconButton 
                    size="small"
                    onClick={() => window.open(`https://open.spotify.com/search/${encodeURIComponent(`${track.track} ${track.artist}`)}`, '_blank')}
                  >
                    <SearchIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
              {track.reason && (
                <Typography variant="caption" color="text.secondary" sx={{ ml: 4, display: 'block', mt: 0.5 }}>
                  {track.reason}
                </Typography>
              )}
            </Box>
          ))}
        </CardContent>
        <CardActions>
          <Button 
            size="small" 
            variant="contained"
            onClick={() => onCreateInSpotify(playlist)}
          >
            Create in Spotify
          </Button>
        </CardActions>
      </Card>
    </Box>
  );
};

export default GeneratedPlaylist;
